export default __webpack_public_path__ + "static/media/onboard_check_gray.28afca75.svg";